import getCookie from '../modules/getCookie';
import Modal from 'bootstrap/js/dist/modal';

/**
 * Attestation site modal
 *
 * @param {String} cookieName
 */
const attestationModal = (cookieName = 'hcpAttestationModal') => {
  const modalEl = document.getElementById('hcpAttestationModal');

  if (modalEl && getCookie(cookieName) !== 'accepted') {
    const functionality = modalEl.dataset.miraFunctionality;
    const closeBtn = modalEl.querySelector('#hcpAttestationModalClose');
    const denyBtn = modalEl.querySelector('#hcpAttestationModalDeny');

    // Automatically show modal
    // eslint-disable-next-line no-undef
    const modal = new Modal(modalEl, {
      backdrop: functionality === 'blocking' ? 'static' : true,
      keyboard: false,
    });
    modal.show();

    const redirectattestationModal = () => {
      window.location.assign(modalEl.dataset.miraRedirectUrl);
    };

    // Redirect if close or 'deny' buttons are clicked
    if (closeBtn && functionality === 'blocking') {
      closeBtn.addEventListener('click', redirectattestationModal);
    }
    if (denyBtn) {
      denyBtn.addEventListener('click', redirectattestationModal);
    }

    modalEl.addEventListener('hide.bs.modal', () => {
      const supressionTime =
        modalEl.dataset.miraSupressionTime * 24 * 60 * 60;

      if (supressionTime > 0) {
        document.cookie = `${cookieName}=accepted; path=/; max-age=${supressionTime};`;
      } else {
        // stores only for session
        document.cookie = `${cookieName}=accepted; path=/;`;
      }
    });
  }
};

export default attestationModal;
